/**
 * Basis Theory Configuration
 *
 * API keys and tenant IDs for Basis Theory integration
 * Key selection based on environment (production vs staging/dev)
 */
export const BASIS_THEORY_CONFIG = {
    production: {
        tenantId: 'b1636929-db11-4b01-b2c2-6a97b3444061',
        publicKey: 'key_prod_us_pub_PNMB2AiaECJ463K6QAPNU6',
    },
    test: {
        tenantId: '99821999-faf5-4427-a92c-9267cb930540',
        publicKey: 'key_test_us_pub_VExdfbFQARn821iqP8zNaq',
    },
};
/**
 * Get Basis Theory keys based on environment
 *
 * @param isProduction - Whether the environment is production
 * @returns Object with tenantId and apiKey
 */
export function getBasisTheoryKeys(isProduction) {
    const config = isProduction ? BASIS_THEORY_CONFIG.production : BASIS_THEORY_CONFIG.test;
    return {
        tenantId: config.tenantId,
        apiKey: config.publicKey,
    };
}
